import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5분
      gcTime: 10 * 60 * 1000, // 10분 (React Query v5: cacheTime -> gcTime)
      refetchOnWindowFocus: false, // 창 포커스 시 자동 갱신 비활성화
      refetchOnReconnect: true, // 네트워크 재연결 시 자동 갱신
      refetchOnMount: true, // 컴포넌트 마운트 시 자동 갱신
      retry: 1, // 실패 시 1회 재시도
      retryDelay: 1000, // 1초 후 재시도
    },
  },
});
